import { thunk } from "redux-thunk";
import RootReducer from "./rootReducer";
import { createLogger } from "redux-logger";
import localStorage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";
import { legacy_createStore, applyMiddleware, compose } from "redux";

/**
 * @description All about redux store
 */

const logger = createLogger({
  predicate: () => process.env.NODE_ENV === "development",
});

const enhancer = compose(applyMiddleware(thunk, logger));

const persistConfig = {
  key: "root",
  blacklist: [],
  storage: localStorage,
  whitelist: ["AuthReducer", "RatingsAndReviewsReducer", "QueriesReducer"],
};

const persistedReducer = persistReducer(persistConfig, RootReducer);

export const store = legacy_createStore(persistedReducer, enhancer);
export const persistor = persistStore(store);
